import { render, staticRenderFns } from "./StaffInformation.vue?vue&type=template&id=572ff437&scoped=true&"
import script from "./StaffInformation.vue?vue&type=script&lang=js&"
export * from "./StaffInformation.vue?vue&type=script&lang=js&"
import style0 from "./StaffInformation.vue?vue&type=style&index=0&id=572ff437&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ff437",
  null
  
)

export default component.exports